import { useState, useEffect, useCallback } from "react";
import { fetchItems } from "../api/items";
import type { ItemListEntry } from "../types";

export function useTopStories(minScore = 80, maxItems = 3) {
  const [items, setItems] = useState<ItemListEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const result = await fetchItems({
        page: 1,
        page_size: maxItems,
        min_score: minScore,
      });
      setItems(result.items);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [minScore, maxItems]);

  useEffect(() => {
    load();
  }, [load]);

  return { items, loading, refresh: load };
}
